import { EntityName, Page } from '@/components';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import SSRDepositorsChart from './SSRDepositorsChart';
import SSRDepositorsTable from './SSRDepositorsTable';

export default function SSRDespositorsPage() {
  const { pagination, sorting, filters } = useTableProps({
    filtersDebounceTime: 250,
    pageSize: 10,
    initialSorting: '-balance',
    initialFilters: {
      textSearch: ''
    }
  });
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'USDS'}
              address={tokensMapping('USDS').address}
              size="4"
            />
          }>
          <Heading size="1">Sky Savings Rate Suppliers</Heading>
        </EntityName>
      }>
      <SSRDepositorsChart />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSeatchFilter
          filters={filters}
          placeholder="Search by wallet address"
        />
      </Flex>
      <SSRDepositorsTable
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
